import { render } from "./NavTabs.vue?vue&type=template&id=1dfa7a46"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"
script.render = render

export default script